module.exports = __webpack_public_path__ + "images/bar-chart-734ce77a.svg";